// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2RDL1","inputDescription":"styles_inputDescription__9EM8p"};